<template>
  <v-flex xs12 pt-0 mt-1 style="cursor: pointer" @click="toogleView">
    <v-layout row wrap>
      <v-flex xs12 py-0>
        <v-container py-3 px-0>
          <v-layout row wrap>
            <v-flex xs12 md8 text-xs-center text-sm-left>
              <v-layout row wrap style="font-size: 13px">
                <v-flex xs12 py-0 class="hidden-xs-only">
                  <span class="font-weight-bold color-logo-green uppercase">{{record.social_name}}</span>
                  <span class="font-weight-light" v-if='isRfcPfWithoutCurp'>
                      RFC {{ mask('rfc_pf', record.rfc_pf) }}
                  </span>
                  <span class="font-weight-light" v-if='!isRfcPfWithoutCurp'>
                    {{record.document_type.toUpperCase()}} {{mask(record.document_type, record.document_number)}}
                  </span>
                </v-flex>
                <v-flex xs12 py-0 class="hidden-xs-only color-dark-blue">
                  {{updated_time_label}} {{since_updated_time}}
                </v-flex>
                <v-flex xs12 py-0 class="hidden-sm-and-up">

                    {{ record.document_type.toUpperCase() }}
                    {{ mask(record.document_type, record.document_number) }}

                </v-flex>
                <v-flex xs12 py-0 class="hidden-sm-and-up">
                  {{record.social_name}}
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 md4 py-0 text-md-right text-xs-center>
              <v-layout row wrap caption>
                <v-flex xs12 py-0>
                  {{i18n('Nível atual')}}: {{record.clearance_level}}
                  <v-icon class="arrow-icon-small">arrow_forward</v-icon>
                  {{i18n('Nível necessário')}}: {{record.required_clearance_level}}
                  <div class="company__source_info"></div>
                </v-flex>
              </v-layout>
            </v-flex>

            <transition name="fade">
              <v-flex xs12 mt-3 v-if="current_view === 'detailed'" @click="stopUnlessUploading">
                <company-form operation="update" subject @onUpdate="onUpdate" @cancelled="onCancel" :record="record" v-if="isCompany" />
                <person-form operation="update" subject @onUpdate="onUpdate" @cancelled="onCancel" :record="record" v-if="isPerson" />
              </v-flex>
            </transition>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <v-divider />
  </v-flex>
</template>
<script>
import utils from "./shared/Utils"
import AdminCompanyForm from "./AdminCompanyForm"
import AdminPersonForm from "./AdminPersonForm"

export default {
  name: 'CustomersItem',
  components: { 'company-form': AdminCompanyForm, 'person-form': AdminPersonForm },
  props: {
    record: {
      type: Object
    }
  },
  data() {
    return {
      current_view: 'short',
    }
  },
  computed: {
    url() {
      return this.$root.urls.admin_companies
    },
    updated_time_label() {
      if (this.record.status == 'reproved') return this.i18n('Reprovado há')
      if (this.record.status == 'approved') return this.i18n('Aprovado há')
      return this.i18n('Aguardando há')
    },
    since_updated_time() {
      if (this.record.status == 'reproved' || this.record.status == 'approved') {
        return this.sinceDbDateTimeToHuman(this.record.updated_at)
      }
      return this.sinceDbBusinessDateTimeToHuman(this.record.updated_at)
    },
    isPerson() {
      return utils.isPerson(this.record)
    },
    isCompany() {
      return utils.isCompany(this.record)
    },
    isRfcPfWithoutCurp() {
      return utils.isRfcPfWithoutCurp(this.record)
    }
  },
  methods: {
    i18n(str) {
      return this.$root.l(str)
    },
    stopUnlessUploading(e) {
      if (e.target.type === 'file') {
        return true
      } else {
        e.preventDefault()
        e.stopPropagation()
        return false
      }
    },
    toogleView(e) {
      if (!e || e.target.type !== 'file') {
        this.current_view = (this.current_view === 'short') ? 'detailed' : 'short'
        this.$emit('onViewChange', this.current_view, this.record)
        e && e.preventDefault()
      }
    },
    l(number_value, currency) {
      return utils.currencyToLocal(number_value, currency)
    },
    mask(format, value) {
      if(value == ''){
        return ''
      } else {
        return utils.mask(format, value)
      }
    },
    dbDateTimeToHuman(value) {
      return utils.dbDateTimeToHuman(value)
    },
    sinceDbDateTimeToHuman(value) {
      return utils.sinceDbDateTimeToHuman(value, this.$root.lang)
    },
    sinceDbBusinessDateTimeToHuman(value) {
      return utils.sinceDbBusinessDateTimeToHuman(value, this.$root.lang)
    },
    onUpdate() {
      this.$emit('onUpdate', this.record)
      this.toogleView(false)
    },
    onCancel() {
      this.toogleView(false)
    }
  },
  mounted() {
    this.record = utils.letShowEmptyCurpIfRequired(this.record);
  }
}
</script>
<style>
  .company__source_info {
    color: var(--silver-color-font-color);
  }
</style>



// WEBPACK FOOTER //
// src/CustomersItem.vue